import { SocketClient } from "cbcore-ts"
import { NO, UIColor, UIRoute, UITextView, UIView, UIViewController, YES } from "uicore-ts"
import { RHCore } from "./Core/RHCore"
import { EChartsView } from "./Custom components/EChartsView"
import { RHFocusManager } from "./Custom components/RH/Keyboard navigation/RHFocusManager"
import { RHPageFocusManager } from "./Custom components/RH/Keyboard navigation/RHPageFocusManager"
import { RHButton } from "./Custom components/RH/RHButton"
import { RHEuroFormatter } from "./Custom components/RH/Utils_slop/RHEuroFormatter"
import { StatisticsPageDesignTokens } from "./Custom components/RH/Utils_slop/StatisticsPageDesignTokens"
import { StatisticsPageViewStyling } from "./Custom components/RH/Utils_slop/StatisticsPageViewStyling"
import { RHRStatisticsComparisonViewController } from "./RHRStatisticsComparisonViewController"
import { RHRStatisticsViewController } from "./RHRStatisticsViewController"
import { RHButtons, RHFont, RHNavbar, RHSpacing, RHTables } from "./Custom components/RH/Utils_slop/RHDesignTokens"
import type { EChartsShowTooltipEvent, EChartsTooltipValue } from "./Custom components/EChartsView"


export class StatisticsMainViewController extends UIViewController {

    private _hasInitializedDashboard = NO


    readonly titleLabel: UITextView = new UITextView(
        this.view.elementID + "TitleLabel",
        UITextView.type.header2
    ).configuredWithObject({
        text: "RHR-i avalik statistika",
        hoverText: "",
        backgroundColor: UIColor.transparentColor,
        textAlignment: UITextView.textAlignment.center,
        style: {
            fontFamily: RHFont.familyBase,
            fontSize: RHFont.sizeXLarge,
            fontWeight: "500",
            lineHeight: RHFont.lineHeightHeading,
            color: StatisticsPageDesignTokens.titleTextColor.stringValue
        }
    }).addedAsSubviewToView(this.view)

    explanationView: UITextView = new UITextView().addedAsSubviewToView(this.view).configuredWithObject({
        text: "Siin on võimalik võrrelda hankijaid " +
            "<a href=\"https://riigihanked.riik.ee/rhr-web/\" style=\"color: " +
            RHNavbar.topBarTopBarBackground.stringValue + "; text-decoration: underline;\">" +
            "Riigihangete registri" +
            "</a> " +
            "avaliku info põhjal koostatud statistika võtmes.",
        textAlignment: UITextView.textAlignment.center,
        isSingleLine: NO,
        style: {
            fontFamily: RHFont.familyBase,
            fontSize: RHFont.sizeXSmall,
            fontWeight: StatisticsPageDesignTokens.explanationFontWeight,
            color: StatisticsPageDesignTokens.explanationTextColor.stringValue,
            lineHeight: RHFont.lineHeightBase
        }
    })

    // Grouping buttons for layout convenience
    procurerButtonsContainer = new UIView().addedAsSubviewToView(this.view)
    offererButtonsContainer = new UIView().addedAsSubviewToView(this.view)

    procurerStatisticsButton: RHButton = new RHButton().addedAsSubviewToView(this.procurerButtonsContainer)
        .configuredWithObject({
            titleLabel: {
                text: "Hankija statistika"
            },
            variant: StatisticsPageDesignTokens.frontCtaButtonVariant,
            contentPadding: RHButtons.compactContentPadding,
            controlEventTargetAccumulator: {
                PrimaryActionTriggered: (sender, event) => {
                    UIRoute.currentRoute.routeWithComponent(
                        RHRStatisticsViewController.routeComponentName,
                        { [RHRStatisticsViewController.ParameterIdentifierName.entityType]: "procurer" }
                    ).routeByRemovingComponentNamed(StatisticsMainViewController.routeComponentName).apply()
                }
            },
            hoverText: "Vaata ühe hankija statistikat erinevatel perioodidel",
            style: {
                fontSize: RHButtons.compactFontSize
            }
        })

    procurersComparisonButton: RHButton = new RHButton().addedAsSubviewToView(this.procurerButtonsContainer)
        .configuredWithObject({
            titleLabel: {
                text: "Hankijate võrdlus"
            },
            variant: StatisticsPageDesignTokens.frontCtaButtonVariant,
            contentPadding: RHButtons.compactContentPadding,
            controlEventTargetAccumulator: {
                PrimaryActionTriggered: (sender, event) => {
                    UIRoute.currentRoute.routeWithComponent(
                        RHRStatisticsComparisonViewController.routeComponentName,
                        {
                            [RHRStatisticsComparisonViewController.ParameterIdentifierName.entityType]: "procurer"
                        }
                    ).routeByRemovingComponentNamed(StatisticsMainViewController.routeComponentName).apply()
                }
            },
            hoverText: "Võrdle erinevate hankijate statistikat",
            style: {
                fontSize: RHButtons.compactFontSize
            }
        })

    offererStatisticsButton: RHButton = new RHButton().addedAsSubviewToView(this.offererButtonsContainer)
        .configuredWithObject({
            titleLabel: {
                text: "Pakkuja statistika"
            },
            variant: StatisticsPageDesignTokens.frontCtaButtonVariant,
            contentPadding: RHButtons.compactContentPadding,
            controlEventTargetAccumulator: {
                PrimaryActionTriggered: (sender, event) => {
                    UIRoute.currentRoute.routeWithComponent(
                        RHRStatisticsViewController.routeComponentName,
                        { [RHRStatisticsViewController.ParameterIdentifierName.entityType]: "offerer" }
                    ).routeByRemovingComponentNamed(StatisticsMainViewController.routeComponentName).apply()
                }
            },
            hoverText: "Vaata ühe pakkuja statistikat erinevatel perioodidel",
            style: {
                fontSize: RHButtons.compactFontSize
            }
        })

    offerersComparisonButton: RHButton = new RHButton().addedAsSubviewToView(this.offererButtonsContainer)
        .configuredWithObject({
            titleLabel: {
                text: "Pakkujate võrdlus"
            },
            variant: StatisticsPageDesignTokens.frontCtaButtonVariant,
            contentPadding: RHButtons.compactContentPadding,
            controlEventTargetAccumulator: {
                PrimaryActionTriggered: (sender, event) => {
                    UIRoute.currentRoute.routeWithComponent(
                        RHRStatisticsComparisonViewController.routeComponentName,
                        {
                            [RHRStatisticsComparisonViewController.ParameterIdentifierName.entityType]: "offerer"
                        }
                    ).routeByRemovingComponentNamed(StatisticsMainViewController.routeComponentName).apply()
                }
            },
            hoverText: "Võrdle erinevate pakkujate statistikat",
            style: {
                fontSize: RHButtons.compactFontSize
            }
        })


    frontDashboardView = new UIView().addedAsSubviewToView(this.view)
        .configuredWithObject({
            backgroundColor: StatisticsPageDesignTokens.chartPanelBackgroundColor,
            style: {
                border: `1px solid ${RHTables.dataViewBorderColor.stringValue}`,
                borderRadius: RHTables.dataViewBorderRadius,
                boxShadow: RHTables.dataViewBoxShadow
            },
            layoutSubviews: () => {
                const bounds = this.frontDashboardView.contentBoundsWithInset(
                    RHSpacing.small
                )
                this.topStatisticsChart.frame = bounds
            }
        })


    // Toggle Buttons for Chart
    chartTogglesContainer = new UIView().addedAsSubviewToView(this.view)

    topProcurersByCountButton = new RHButton().addedAsSubviewToView(this.chartTogglesContainer)
        .configuredWithObject({
            titleLabel: {
                text: "Hankijad (Arv)"
            },
            variant: StatisticsPageDesignTokens.chartToggleSelectedVariant,
            contentPadding: RHButtons.compactContentPadding,
            style: {
                fontSize: RHButtons.compactFontSize
            },
            controlEventTargetAccumulator: {
                PrimaryActionTriggered: (sender, event) => {
                    this.updateChartButtonsSelection(this.topProcurersByCountButton)
                    this.topStatisticsChart.dataAndConfiguration = this
                        ._mostProcurerContractsChartDataAndConfiguration
                }
            }
        })

    topProcurersByMonetarySumButton = new RHButton()
        .addedAsSubviewToView(this.chartTogglesContainer)
        .configuredWithObject({
            titleLabel: {
                text: "Hankijad (Maksumus)"
            },
            variant: StatisticsPageDesignTokens.chartToggleUnselectedVariant,
            contentPadding: RHButtons.compactContentPadding,
            style: {
                fontSize: RHButtons.compactFontSize
            },
            controlEventTargetAccumulator: {
                PrimaryActionTriggered: (sender, event) => {
                    this.updateChartButtonsSelection(this.topProcurersByMonetarySumButton)
                    this.topStatisticsChart.dataAndConfiguration = this
                        ._mostProcurerContractsMoneyChartDataAndConfiguration
                }
            }
        })

    topOfferersByCountButton = new RHButton()
        .addedAsSubviewToView(this.chartTogglesContainer)
        .configuredWithObject({
            titleLabel: {
                text: "Partnerid (Arv)"
            },
            variant: StatisticsPageDesignTokens.chartToggleUnselectedVariant,
            contentPadding: RHButtons.compactContentPadding,
            style: {
                fontSize: RHButtons.compactFontSize
            },
            controlEventTargetAccumulator: {
                PrimaryActionTriggered: (sender, event) => {
                    this.updateChartButtonsSelection(this.topOfferersByCountButton)
                    this.topStatisticsChart.dataAndConfiguration = this
                        ._mostOffererContractsChartDataAndConfiguration
                }
            }
        })

    topOfferersByMonetarySumButton = new RHButton().addedAsSubviewToView(this.chartTogglesContainer)
        .configuredWithObject({
            titleLabel: {
                text: "Partnerid (Maksumus)"
            },
            variant: StatisticsPageDesignTokens.chartToggleUnselectedVariant,
            contentPadding: RHButtons.compactContentPadding,
            style: {
                fontSize: RHButtons.compactFontSize
            },
            controlEventTargetAccumulator: {
                PrimaryActionTriggered: (sender, event) => {
                    this.updateChartButtonsSelection(this.topOfferersByMonetarySumButton)
                    this.topStatisticsChart.dataAndConfiguration = this
                        ._mostOffererContractsMoneyChartDataAndConfiguration
                }
            }
        })

    _mostProcurerContractsChartDataAndConfiguration: typeof this.topStatisticsChart.dataAndConfiguration = {}
    _mostProcurerContractsMoneyChartDataAndConfiguration: typeof this.topStatisticsChart.dataAndConfiguration = {}
    _mostOffererContractsChartDataAndConfiguration: typeof this.topStatisticsChart.dataAndConfiguration = {}
    _mostOffererContractsMoneyChartDataAndConfiguration: typeof this.topStatisticsChart.dataAndConfiguration = {}

    topStatisticsChart = new EChartsView().addedAsSubviewToView(this.frontDashboardView)


    bottomView = new UIView().addedAsSubviewToView(this.view)

    override _focusManager = new RHFocusManager(() => [
        this.procurerStatisticsButton,
        this.procurersComparisonButton,
        this.offererStatisticsButton,
        this.offerersComparisonButton,
        this.topProcurersByCountButton,
        this.topProcurersByMonetarySumButton,
        this.topOfferersByCountButton,
        this.topOfferersByMonetarySumButton
    ])


    constructor(view: UIView) {

        super(view)

        this.view.configureWithObject({
            backgroundColor: StatisticsPageDesignTokens.pageBackgroundColor,
            hoverText: ""
        })
        this.topStatisticsChart.chartContentInset = 0

    }


    updateChartButtonsSelection(selectedButton: RHButton) {
        const buttons = [
            this.topProcurersByCountButton,
            this.topProcurersByMonetarySumButton,
            this.topOfferersByCountButton,
            this.topOfferersByMonetarySumButton
        ]

        buttons.forEach(btn => {
            btn.selected = NO
            if (btn == selectedButton) {
                btn.variant = StatisticsPageDesignTokens.chartToggleSelectedVariant
            }
            else {
                btn.variant = StatisticsPageDesignTokens.chartToggleUnselectedVariant
            }
        })
    }

    private chartTitleConfiguration(text: string, subtext: string) {
        return {
            text: text,
            subtext: subtext,
            left: "center",
            top: 14,
            textStyle: {
                color: StatisticsPageDesignTokens.chartTitleTextColor,
                fontSize: StatisticsPageDesignTokens.chartTitleFontSize,
                fontWeight: StatisticsPageDesignTokens.chartTitleFontWeight
            },
            subtextStyle: {
                color: StatisticsPageDesignTokens.chartSubtitleTextColor,
                fontSize: 12
            }
        }
    }

    private chartGridConfiguration() {
        return {
            left: 82,
            right: 124,
            top: 76,
            bottom: 154,
            containLabel: YES
        }
    }

    private chartCategoryAxisConfiguration(data: string[]) {
        return {
            type: "category",
            data: data,
            axisLabel: {
                interval: 0,
                rotate: -28,
                fontSize: StatisticsPageDesignTokens.chartAxisLabelFontSize,
                color: StatisticsPageDesignTokens.chartAxisTextColor,
                margin: 18,
                width: 118,
                overflow: "truncate",
                ellipsis: "...",
                hideOverlap: YES
            },
            axisTick: {
                alignWithLabel: YES,
                lineStyle: { color: StatisticsPageDesignTokens.chartAxisLineColor }
            },
            axisLine: { lineStyle: { color: StatisticsPageDesignTokens.chartAxisLineColor } }
        }
    }

    private compactMonetaryAxisValue(value: number) {
        const absoluteValue = Math.abs(Number(value))
        if (absoluteValue >= 1000000000) {
            return (value / 1000000000).toLocaleString("et-EE", { maximumFractionDigits: 1 }) + " mld"
        }
        if (absoluteValue >= 1000000) {
            return (value / 1000000).toLocaleString("et-EE", { maximumFractionDigits: 0 }) + " mln"
        }
        if (absoluteValue >= 1000) {
            return (value / 1000).toLocaleString("et-EE", { maximumFractionDigits: 0 }) + " tuh"
        }
        return value
    }

    private capitalizedStatisticsEntityName(name: string) {
        if (!name) {
            return ""
        }
        return name.charAt(0).toUpperCase() + name.slice(1)
    }

    private normalizedStatisticsEntityNames(names: string[]) {
        const wordsToRemove = ["oü", "as", "aktsiaselts", "osaühing", "sihtasutus", "sa"]
        const result = names.map(
            name => this.capitalizedStatisticsEntityName(
                name.split(" ")
                    .filter(
                        word => !wordsToRemove.contains(word.toLowerCase())
                    ).join(" ")
            )
        )

        return result
    }

    private chartTooltipValueFormatter(
        value: EChartsTooltipValue,
        showTooltipEvent: EChartsShowTooltipEvent
    ): EChartsTooltipValue {
        if (showTooltipEvent?.seriesIndex == 1) {
            return RHEuroFormatter.formattedAmount(Number(value))
        }

        return value
    }

    private chartValueAxesConfiguration() {
        return [
            {
                type: "value",
                name: "Lepingute arv",
                splitLine: { show: YES, lineStyle: { color: StatisticsPageDesignTokens.chartSplitLineColor } },
                nameLocation: "middle",
                nameGap: 48,
                nameTextStyle: {
                    color: StatisticsPageDesignTokens.chartAxisTextColor,
                    fontSize: StatisticsPageDesignTokens.chartAxisLabelFontSize
                },
                axisLabel: {
                    color: StatisticsPageDesignTokens.chartAxisTextColor,
                    fontSize: StatisticsPageDesignTokens.chartAxisLabelFontSize,
                    margin: StatisticsPageDesignTokens.chartYAxisLabelMargin
                }
            },
            {
                type: "value",
                name: "Maksumus (EUR)",
                position: "right",
                splitLine: { show: NO },
                nameLocation: "middle",
                nameGap: 82,
                nameTextStyle: {
                    color: StatisticsPageDesignTokens.chartAxisTextColor,
                    fontSize: StatisticsPageDesignTokens.chartAxisLabelFontSize
                },
                axisLabel: {
                    color: StatisticsPageDesignTokens.chartAxisTextColor,
                    fontSize: StatisticsPageDesignTokens.chartAxisLabelFontSize,
                    margin: StatisticsPageDesignTokens.chartYAxisLabelMargin,
                    formatter: this.compactMonetaryAxisValue
                },
                nameRotate: -90
            }
        ]
    }

    private chartDataZoomConfiguration() {
        return [
            {
                type: "slider",
                start: 0,
                end: 10,
                zoomLock: NO,
                bottom: 22,
                height: 24,
                showDetail: NO,
                showDataShadow: NO,
                brushSelect: NO,
                backgroundColor: StatisticsPageDesignTokens.chartDataZoomBackgroundColor,
                fillerColor: StatisticsPageDesignTokens.chartDataZoomFillerColor,
                borderColor: StatisticsPageDesignTokens.chartDataZoomBorderColor,
                handleSize: "85%",
                handleStyle: {
                    color: StatisticsPageDesignTokens.chartDataZoomHandleColor,
                    borderColor: StatisticsPageDesignTokens.chartDataZoomHandleBorderColor,
                    borderWidth: 1,
                    shadowBlur: 4,
                    shadowColor: StatisticsPageDesignTokens.chartDataZoomHandleShadowColor
                },
                moveHandleStyle: {
                    color: StatisticsPageDesignTokens.chartDataZoomHandleBorderColor
                },
                emphasis: {
                    handleStyle: {
                        borderColor: RHNavbar.topBarTopBarBackground.stringValue
                    },
                    moveHandleStyle: {
                        color: RHNavbar.topBarTopBarBackground.stringValue
                    }
                }
            },
            { type: "inside", zoomOnMouseWheel: NO }
        ]
    }


    async initDashboard() {


        const periodStartDate = new Date()
        periodStartDate.setUTCHours(0)
        periodStartDate.setUTCMinutes(0)
        periodStartDate.setUTCSeconds(0)
        periodStartDate.setUTCMilliseconds(0)
        periodStartDate.setUTCFullYear(periodStartDate.getUTCFullYear() - 1)

        this.topStatisticsChart.dataAndConfiguration = {
            title: {
                text: "Laen statistikat",
                left: "center",
                top: "middle",
                textStyle: {
                    color: StatisticsPageDesignTokens.chartSubtitleTextColor,
                    fontSize: StatisticsPageDesignTokens.chartTitleFontSize,
                    fontWeight: StatisticsPageDesignTokens.chartTitleFontWeight
                }
            }
        }
        this.frontDashboardView.loading = YES
        this.frontDashboardView.setNeedsLayoutUpToRootView()
        UIView.layoutViewsIfNeeded()
        await new Promise<void>(resolve => requestAnimationFrame(() => resolve()))
        const [
            topProcurersStatistics,
            topOfferersStatistics
        ] = await RHCore.sharedInstance.socketClient.sendMessagesAsGroup(async () =>
                [
                    (await SocketClient.TopProcurerStatistics({})).result,
                    (await SocketClient.TopOffererStatistics({})).result
                ]
            ).catch(error => {
                this.frontDashboardView.loading = NO
                throw error
            })

        const topProcurersStatisticsSortedForMostContracts = topProcurersStatistics.sort(
            (a, b) => b.numberOfContracts - a.numberOfContracts || b.contractMonetarySum - a.contractMonetarySum
        ).slice(0, 300)

        const topProcurersStatisticsSortedForMostMoney = topProcurersStatistics.sort(
            (a, b) => b.contractMonetarySum - a.contractMonetarySum || b.numberOfContracts - a.numberOfContracts
        ).slice(0, 300)


        const topOfferersStatisticsSortedForMostContracts = topOfferersStatistics.sort(
            (a, b) => b.numberOfContracts - a.numberOfContracts || b.contractMonetarySum - a.contractMonetarySum
        ).slice(0, 300)

        const topOfferersStatisticsSortedForMostMoney = topOfferersStatistics.sort(
            (a, b) => b.contractMonetarySum - a.contractMonetarySum || b.numberOfContracts - a.numberOfContracts
        ).slice(0, 300)


        // Configuration objects (kept largely similar but ensuring proper context)
        this._mostProcurerContractsChartDataAndConfiguration = {
            title: this.chartTitleConfiguration(
                "Eesti hankijate TOP 30 (Lepingute arv)",
                "Alates " + periodStartDate.dateString
            ),
            grid: this.chartGridConfiguration(),
            tooltip: {
                trigger: "item",
                backgroundColor: StatisticsPageDesignTokens.chartTooltipBackgroundColor,
                borderColor: StatisticsPageDesignTokens.chartTooltipBorderColor,
                textStyle: { color: StatisticsPageDesignTokens.chartTooltipTextColor },
                cb_valueFormatter: this.chartTooltipValueFormatter
            },
            xAxis: this.chartCategoryAxisConfiguration(this.normalizedStatisticsEntityNames(
                topProcurersStatisticsSortedForMostContracts.everyElement.entityName.UI_elementValues ?? []
            )),
            yAxis: this.chartValueAxesConfiguration(),
            dataZoom: this.chartDataZoomConfiguration(),
            series: [
                {
                    name: "Lepingute arv",
                    type: "bar",
                    data: topProcurersStatisticsSortedForMostContracts.everyElement.numberOfContracts.UI_elementValues,
                    yAxisIndex: 0,
                    barMaxWidth: StatisticsPageDesignTokens.chartBarMaxWidth,
                    itemStyle: { color: RHNavbar.topBarTopBarBackground.stringValue }
                },
                {
                    name: "Maksumus",
                    type: "bar",
                    data: topProcurersStatisticsSortedForMostContracts.everyElement.contractMonetarySum.UI_elementValues,
                    yAxisIndex: 1,
                    barMaxWidth: StatisticsPageDesignTokens.chartBarMaxWidth,
                    itemStyle: { color: StatisticsPageDesignTokens.chartSecondaryColor }
                }
            ]
        }

        this.topStatisticsChart.dataAndConfiguration = this._mostProcurerContractsChartDataAndConfiguration
        this.updateChartButtonsSelection(this.topProcurersByCountButton)

        this.view.setNeedsLayoutUpToRootView()

        this._mostProcurerContractsMoneyChartDataAndConfiguration = {
            title: this.chartTitleConfiguration(
                "Eesti hankijate TOP 30 (Maksumus)",
                "Alates " + periodStartDate.dateString
            ),
            grid: this.chartGridConfiguration(),
            tooltip: {
                trigger: "item",
                backgroundColor: StatisticsPageDesignTokens.chartTooltipBackgroundColor,
                borderColor: StatisticsPageDesignTokens.chartTooltipBorderColor,
                textStyle: { color: StatisticsPageDesignTokens.chartTooltipTextColor },
                cb_valueFormatter: this.chartTooltipValueFormatter
            },
            xAxis: this.chartCategoryAxisConfiguration(this.normalizedStatisticsEntityNames(
                topProcurersStatisticsSortedForMostMoney.everyElement.entityName.UI_elementValues ?? []
            )),
            yAxis: this.chartValueAxesConfiguration(),
            dataZoom: this.chartDataZoomConfiguration(),
            series: [
                {
                    name: "Lepingute arv",
                    type: "bar",
                    data: topProcurersStatisticsSortedForMostMoney.everyElement.numberOfContracts.UI_elementValues,
                    yAxisIndex: 0,
                    barMaxWidth: StatisticsPageDesignTokens.chartBarMaxWidth,
                    itemStyle: { color: RHNavbar.topBarTopBarBackground.stringValue }
                },
                {
                    name: "Maksumus",
                    type: "bar",
                    data: topProcurersStatisticsSortedForMostMoney.everyElement.contractMonetarySum.UI_elementValues,
                    yAxisIndex: 1,
                    barMaxWidth: StatisticsPageDesignTokens.chartBarMaxWidth,
                    itemStyle: { color: StatisticsPageDesignTokens.chartSecondaryColor }
                }
            ]
        }

        this._mostOffererContractsChartDataAndConfiguration = {
            title: this.chartTitleConfiguration(
                "Lepingupartnerite TOP 30 (Lepingute arv)",
                "Alates " + periodStartDate.dateString
            ),
            grid: this.chartGridConfiguration(),
            tooltip: {
                trigger: "item",
                backgroundColor: StatisticsPageDesignTokens.chartTooltipBackgroundColor,
                borderColor: StatisticsPageDesignTokens.chartTooltipBorderColor,
                textStyle: { color: StatisticsPageDesignTokens.chartTooltipTextColor },
                cb_valueFormatter: this.chartTooltipValueFormatter
            },
            xAxis: this.chartCategoryAxisConfiguration(this.normalizedStatisticsEntityNames(
                topOfferersStatisticsSortedForMostContracts.everyElement.entityName.UI_elementValues ?? []
            )),
            yAxis: this.chartValueAxesConfiguration(),
            dataZoom: this.chartDataZoomConfiguration(),
            series: [
                {
                    name: "Lepingute arv",
                    type: "bar",
                    data: topOfferersStatisticsSortedForMostContracts.everyElement.numberOfContracts.UI_elementValues,
                    yAxisIndex: 0,
                    barMaxWidth: StatisticsPageDesignTokens.chartBarMaxWidth,
                    itemStyle: { color: RHNavbar.topBarTopBarBackground.stringValue }
                },
                {
                    name: "Maksumus",
                    type: "bar",
                    data: topOfferersStatisticsSortedForMostContracts.everyElement.contractMonetarySum.UI_elementValues,
                    yAxisIndex: 1,
                    barMaxWidth: StatisticsPageDesignTokens.chartBarMaxWidth,
                    itemStyle: { color: StatisticsPageDesignTokens.chartSecondaryColor }
                }
            ]
        }

        this._mostOffererContractsMoneyChartDataAndConfiguration = {
            title: this.chartTitleConfiguration(
                "Lepingupartnerite TOP 30 (Maksumus)",
                "Alates " + periodStartDate.dateString
            ),
            grid: this.chartGridConfiguration(),
            tooltip: {
                trigger: "item",
                backgroundColor: StatisticsPageDesignTokens.chartTooltipBackgroundColor,
                borderColor: StatisticsPageDesignTokens.chartTooltipBorderColor,
                textStyle: { color: StatisticsPageDesignTokens.chartTooltipTextColor },
                cb_valueFormatter: this.chartTooltipValueFormatter
            },
            xAxis: this.chartCategoryAxisConfiguration(this.normalizedStatisticsEntityNames(
                topOfferersStatisticsSortedForMostMoney.everyElement.entityName.UI_elementValues ?? []
            )),
            yAxis: this.chartValueAxesConfiguration(),
            dataZoom: this.chartDataZoomConfiguration(),
            series: [
                {
                    name: "Lepingute arv",
                    type: "bar",
                    data: topOfferersStatisticsSortedForMostMoney.everyElement.numberOfContracts.UI_elementValues,
                    yAxisIndex: 0,
                    barMaxWidth: StatisticsPageDesignTokens.chartBarMaxWidth,
                    itemStyle: { color: RHNavbar.topBarTopBarBackground.stringValue }
                },
                {
                    name: "Maksumus",
                    type: "bar",
                    data: topOfferersStatisticsSortedForMostMoney.everyElement.contractMonetarySum.UI_elementValues,
                    yAxisIndex: 1,
                    barMaxWidth: StatisticsPageDesignTokens.chartBarMaxWidth,
                    itemStyle: { color: StatisticsPageDesignTokens.chartSecondaryColor }
                }
            ]
        }
        this.frontDashboardView.setNeedsLayoutUpToRootView()
        await StatisticsPageViewStyling.waitForLoadingCompletionFrameBudget()
        this.frontDashboardView.loading = NO

    }

    static override readonly routeComponentName = "stats_front"
    static override readonly ParameterIdentifierName = {}

    override async viewWillAppear() {
        await super.viewWillAppear()
        RHPageFocusManager.shared.registerContentControllerManager(this._focusManager)
        if (!this._hasInitializedDashboard) {
            this._hasInitializedDashboard = YES
            await this.initDashboard()
        }
    }

    override async viewWillDisappear() {
        await super.viewWillDisappear()
        RHPageFocusManager.shared.deregisterContentControllerManager(this._focusManager)
    }

    override async handleRoute(route: UIRoute) {
        super.handleRoute(route)
    }


    override layoutViewSubviews() {

        super.layoutViewSubviews()

        const bounds = this.view.contentBoundsWithInset(RHSpacing.large)
            .rectangleWithMaxWidth(1480, 0.5)
        const ctaRowWidth = [
            bounds.width,
            StatisticsPageDesignTokens.frontCtaButtonWidth * 2 + StatisticsPageDesignTokens.frontCtaButtonGap
        ].min()
        const chartToggleWidth = [
            bounds.width,
            820
        ].min()
        const explanationHeight = [
            this.explanationView.intrinsicContentHeight(StatisticsPageDesignTokens.explanationMaxWidth),
            StatisticsPageDesignTokens.explanationMinHeight
        ].max()

        bounds
            .rectangleWithHeight(32)
            .rectangleByAddingY(RHSpacing.small)
            .assignedAsFrameOfView(this.titleLabel)
            .rectangleForNextRow(RHSpacing.large, explanationHeight)
            .rectangleWithWidth([bounds.width, StatisticsPageDesignTokens.explanationMaxWidth].min(), 0.5)
            .assignedAsFrameOfView(this.explanationView)
            .rectangleForNextRow(
                StatisticsPageDesignTokens.explanationBottomGap,
                RHButtons.compactHeight
            )
            .rectangleWithWidth(ctaRowWidth, 0.5)
            .assignedAsFrameOfView(this.procurerButtonsContainer)
            .performingFunctionWithSelf(() => this.procurerButtonsContainer.bounds.distributeViewsAlongWidth(
                [this.procurerStatisticsButton, this.procurersComparisonButton],
                undefined,
                StatisticsPageDesignTokens.frontCtaButtonGap,
                [
                    StatisticsPageDesignTokens.frontCtaButtonWidth,
                    StatisticsPageDesignTokens.frontCtaButtonWidth
                ]
            ))
            .rectangleForNextRow(
                RHSpacing.small,
                RHButtons.compactHeight
            )
            .assignedAsFrameOfView(this.offererButtonsContainer)
            .performingFunctionWithSelf(() => this.offererButtonsContainer.bounds.distributeViewsAlongWidth(
                [this.offererStatisticsButton, this.offerersComparisonButton],
                undefined,
                StatisticsPageDesignTokens.frontCtaButtonGap,
                [
                    StatisticsPageDesignTokens.frontCtaButtonWidth,
                    StatisticsPageDesignTokens.frontCtaButtonWidth
                ]
            ))
            .rectangleForNextRow(
                RHSpacing.large,
                (RHButtons.compactHeight - RHSpacing.tiny)
            )
            .rectangleWithWidth(chartToggleWidth, 0.5)
            .assignedAsFrameOfView(this.chartTogglesContainer)
            .performingFunctionWithSelf(() => this.chartTogglesContainer.bounds.distributeViewsEquallyAlongWidth([
                this.topProcurersByCountButton,
                this.topProcurersByMonetarySumButton,
                this.topOfferersByCountButton,
                this.topOfferersByMonetarySumButton
            ], RHSpacing.small))
            .rectangleForNextRow(
                RHSpacing.large,
                780
            )
            .rectangleWithWidth(bounds.width, 0.5)
            .assignedAsFrameOfView(this.frontDashboardView)
            .rectangleForNextRow(RHSpacing.large, RHSpacing.xLarge)
            .assignedAsFrameOfView(this.bottomView)

    }


}
